
<!--
    Props:
        items           - An array of items used to build the treeview. Required.
        item-text       - Property on supplied items that contains its label text. Default: 'name'
        item-children   - Property on supplied items that contains its children. Default: 'children'
    ----------------------
    Slots:
        item:
            scopes: "item"
    ----------------------
    Usage example:
    <TreeView
        :items="array"
        item-children="node"
    >
        <template #item="{ item }">
            <span>
                {{ !!item.inn ? item.inn : '-' }}
            </span>
        </template>
    </TreeView>
-->

<template>
  <ul class="tree-view">
    <template v-for="item in items">
      <li>
        <b-icon-caret-down-fill
          v-if="hasChildElements(item)"
          class="tree-view__trigger cursor-pointer"
          v-b-toggle="`treeView-${item.id}`"
        ></b-icon-caret-down-fill>

        <slot name="item" :item="item">
          <span>
            {{ item[itemText] }}
          </span>
        </slot>

        <b-collapse :id="`treeView-${item.id}`">
          <TreeView
            :item-text="itemText"
            :itemChildren="itemChildren"
            :items="item[itemChildren]"
          >
            <template
              v-for="slot in Object.keys($scopedSlots)"
              v-slot:[slot]="scope"
            >
              <slot :name="slot" v-bind="scope" />
            </template>
          </TreeView>
        </b-collapse>
      </li>
    </template>
  </ul>
</template>

<script>
export default {
  name: "TreeView",

  props: {
    items: {
      type: Array,
      required: true,
    },

    itemChildren: {
      type: String,
      default: "children",
    },

    itemText: {
      type: String,
      default: "name",
    },
  },

  methods: {
    hasChildElements(elem) {
      return elem[this.itemChildren].length > 0 ;
    },
  },
};
</script>

<style scoped lang="scss">
.tree-view {
  &__trigger {
    transition: 300ms;
    &.not-collapsed {
      transform: rotate(-90deg);
    }
  }
  .tree-view {
    margin-left: 30px;
  }
}
</style>
